import React from 'react';
import SelectComponent from './select-component';

export const BtnSelectFilter = props => <SelectComponent {...props} />;
export const TextSelectFilter = props => (
  <SelectComponent {...props} showSelectedOption hasOutlinedIcon={false} noBtnBorder={true} />
);
const SelectFilter = props => <SelectComponent {...props} />;

export default SelectFilter;
